// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ServiceProviderDev1  {
    _originalTypeClassName = "Loom.BO.ServiceProviderDev1";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ServiceProviderDev1.translate = translateService;
}
this.ServiceProviderDev1Key = null;
this._key = this.ServiceProviderDev1Key = 0; 
}

static translate: TranslateService;
_key: any;
private _ServiceProviderDev1Key:any;
get ServiceProviderDev1Key(): any {
    return this._ServiceProviderDev1Key;
  }
set ServiceProviderDev1Key(value: any) {
    this._ServiceProviderDev1Key = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ServiceProviderDev1Key == null || $this.ServiceProviderDev1Key == 0;
            }


}